export const UNION_R_API = {
  taskPage: '/live/hiya_socialize/union_r_task_page',
  rewardRecords: '/live/hiya_socialize/union_r_reward_records',
} as const

export const FALLBACK_ROOM_ID = 90001

export const BTN_TYPE = {
  none: 0,
  chat: 1,
  invite: 2,
} as const

export const CURRENT_KIND = {
  connect: 'connect',
  stay: 'stay',
  gift: 'gift',
} as const

export const REWARD_TYPE = {
  pearl: 1,
  headFrame: 2,
  coin: 3,
} as const
